import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BirthdayService {

  private location = '/api/resultpage/';

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'api-key': 'check24at',
      'x-from-service': 'frontend-resultpage',
    }),
    responseType: 'text' as 'json',
  };

  constructor(
    private http: HttpClient,
  ) { }

  public validateBday(token: any, birthday: string): Observable<{message:string,seconds:number,error:boolean}> {
    let url = this.location + encodeURIComponent(token) + '/validateBday';
    return this.http.post<{message:string,seconds:number,error:boolean}>(url, JSON.stringify(birthday), this.httpOptions)
      .pipe(
        catchError(this.handleError<any>('validateBday'))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return throwError(() => {
        return error;
      });
    };
  }
}
